import { render, staticRenderFns } from "./CustomerMessagesWrapper.vue?vue&type=template&id=6e8111a4&"
import script from "./CustomerMessagesWrapper.vue?vue&type=script&lang=js&"
export * from "./CustomerMessagesWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports